import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  withArrow?: boolean;
  pulse?: boolean;
  id?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  withArrow = false,
  pulse = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-bold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-sage text-white hover:bg-sage-dark shadow-lg hover:shadow-xl focus:ring-sage',
    secondary: 'bg-navy text-white hover:bg-opacity-90 shadow-md hover:shadow-lg focus:ring-navy',
    outline: 'border-2 border-sage text-sage hover:bg-sage hover:text-white focus:ring-sage'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={pulse ? {
    boxShadow: ['0 0 0 0 rgba(127, 168, 130, 0.4)', '0 0 0 10px rgba(127, 168, 130, 0)']
  } : {}} transition={pulse ? {
    repeat: Infinity,
    duration: 2
  } : {}} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-132">
      {children}
      {withArrow && <ArrowRight className="ml-2 h-5 w-5" data-id="element-133" />}
    </motion.button>;
}